import {createSvgIcon} from '../create-svg-icon';

export const CallMissedOutgoingIcon = createSvgIcon(
  <path d="m3 8.41 9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z" />
, 'CallMissedOutgoingOutlined');
